
export class StatisticEvent {
	_id:string;
	customer: string;
    event: string;
	createdAt: Date;
}


// WEBPACK FOOTER //
// ./src/app/_models/statisticevent.ts